import "swiper/css";

import Radium from "radium";
import SectionLabel from "./SectionLabel";
import { Swiper } from "swiper/react";
import { useRef } from "react";

// Import Swiper styles

const SliderSection = ({
  children,
  title,
  subTitle,
  sectionLabel,
  buttonsLabelData,
  withArrows,
  sliderSectionStyle,
  spaceBetween,
  refSection,
  className,
}) => {
  const swiperRef = useRef(null);
  //Buttons to move the slide WIP
  const SwiperArrowButtons = () => {
    return (
      <div style={styles.sliderSection.title.arrows.buttons}>
        <button
          style={styles.sliderSection.title.arrows.buttons.button}
          onClick={() => swiperRef.current.swiper.slidePrev()}
        >
          <h1 style={styles.sliderSection.title.arrows.buttons.button.h1}>{"<"}</h1>
        </button>
        <button
          style={styles.sliderSection.title.arrows.buttons.button}
          onClick={() => swiperRef.current.swiper.slideNext()}
        >
          <h1 style={styles.sliderSection.title.arrows.buttons.button.h1}>{">"}</h1>
        </button>
      </div>
    );
  };

  return (
    <div style={{ ...styles.sliderSection, ...sliderSectionStyle }} className={className}>
      <div style={styles.sliderSection.title}>
        <div style={styles.sliderSection.title.text}>
          <h1 style={styles.sliderSection.title.text.h1} ref={refSection ? refSection : null}>
            {title}
          </h1>
          <h3 style={styles.sliderSection.title.text.h3}>{subTitle}</h3>
        </div>
        {sectionLabel && (
          <div style={styles.sliderSection.title.labels}>
            <SectionLabel data={buttonsLabelData} />
          </div>
        )}
        {withArrows && (
          <div style={styles.sliderSection.title.arrows}>
            <SwiperArrowButtons />
          </div>
        )}
      </div>

      <Swiper
        spaceBetween={spaceBetween ? spaceBetween : 20}
        slidesPerView={"auto"}
        onSlideChange={(e) => console.log(e)}
        onSwiper={(swiper) => console.log(swiper)}
        grabCursor={true}
        ref={swiperRef}
        style={{ overflowX: "auto" }}
      >
        {children}
      </Swiper>
    </div>
  );
};

export default Radium(SliderSection);

const query = {
  xs: "@media (max-width: 576px)",
  sm: "@media (max-width: 768px)",
  md: "@media (max-width: 992px)",
  lg: "@media (max-width: 1200px)",
  xl: "@media (max-width: 1600px)",
  small: "@media (max-width: 600px)",
  medium: "@media (max-width: 1440px)",
  large: "@media (max-width: 1700px)",
};

const styles = {
  sliderSection: {
    width: "100%",
    backgroundColor: "rgb(240, 250, 230)",
    height: "490px",
    padding: "8px",

    title: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      flexWrap: "wrap",
      width: "100%",
      marginBottom: "32px",
      text: {
        display: "flex",
        alignItems: "center",
        width: "max-content",
        h1: { fontWeight: "700", color: "#2B3674", margin: 0 },
        h3: { fontWeight: "700", color: "#78D504", margin: "0 8px" },
      },
      labels: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "65%",
        [query.xs]: { width: "100%" },
      },

      arrows: {
        display: "flex",
        width: "6%",
        justifyContent: "flex-end",
        marginRight: "50px",
        [query.lg]: { marginRight: "90px" },
        [query.sm]: { marginRight: "50px" },
        buttons: {
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          button: { border: 0, backgroundColor: "transparent", h1: { margin: 0 } },
        },
      },
    },
  },
};
